import React, { useState } from 'react';
import { Voucher, VoucherCode } from 'utils/Voucher';
import { Button } from './Button';
import { Icon, IconLoader } from './Icon';
import { TextField } from './TextField';
import { alertCircleIcon, checkCircleIcon } from 'assets/icons';
import { requests } from 'api-services';

export type AppliedVoucherInfo = {
  code: VoucherCode,
  voucher?: Voucher,
}

export interface VoucherApplyFieldProps {
  onApply: (voucher: Voucher) => void
}

const VoucherApplyField = ({ onApply }: VoucherApplyFieldProps) => {
  const [voucherField, setVoucherField] = useState('');
  const [lastAppliedVoucher, setLastAppliedVoucher] = useState({} as AppliedVoucherInfo);
  const [state, setState] = useState<'ready' | 'applying' | 'invalid' | 'success'>('ready');

  const applyVoucher = (code: VoucherCode) => {
    setLastAppliedVoucher({ code });
    if (code && code.length > 0) {
      setState('applying');
      requests.voucher.get(code)
        .then((voucher) => {
          setLastAppliedVoucher({ code, voucher });
          if (voucher.isValid) onApply(voucher);
          setState('success');
        })
        .catch(() => {
          setLastAppliedVoucher({ code, voucher: undefined });
          setState('invalid');
        });
    } else {
      setState('invalid');
    }
  };
  
  return <div id='voucher-apply-container' className='pt-2 pb-8'>
    <div className='flex flex-row place-content-center align-middle'>
      <label htmlFor='voucher-field' className='flex items-center'>Apply voucher:</label>
      <span className='px-4 relative'>
        <span className='absolute p-3 right-3'>
          {voucherField === lastAppliedVoucher.code && state === 'success'
            && <Icon title='Voucher submitted successfully' src={checkCircleIcon} />}
          {voucherField === lastAppliedVoucher.code && state === 'invalid'
            && <Icon title='Invalid voucher' src={alertCircleIcon} />}
          {state === 'applying' && <IconLoader />}
        </span>
        <TextField
          id='voucher-field'
          value={voucherField}
          onChange={event => setVoucherField(event.target.value)}
          className='pr-4' />
      </span>
      <span className='flex items-center'>
        <Button
          id='apply-voucher-button'
          primary
          onClick={() => applyVoucher(`${voucherField}`)}>Apply</Button>
      </span>
    </div>
    <div className='mt-1 text-red-600'>
      {state === 'applying' && <div id='voucher-apply-progress'>Applying voucher {lastAppliedVoucher.code}...</div>}  
      {state === 'invalid' && lastAppliedVoucher.code?.length === 0
        && <div id='voucher-err'>Please enter a voucher code.</div>}
      {state === 'invalid' && lastAppliedVoucher.code?.length > 0
        && <div id='voucher-err'>Voucher &quot;{lastAppliedVoucher.code}&quot; is not available.</div>}
    </div>
  </div>;
};

export default VoucherApplyField;
